import React from 'react';
import filterCSV from '../lib/utils/filterCSV';
import type CSVHeaderColumn from '../types/CSVHeaderColumn';
import type CSVRow from '../types/CSVRow';

export default function useBulkImportCSV(isHidingEmptyData: boolean) {
  const [headers, setHeaders] = React.useState<CSVHeaderColumn[]>([]);
  const [rows, setRows] = React.useState<CSVRow[]>([]);
  const [filteredHeaders, setFilteredHeaders] = React.useState<
    CSVHeaderColumn[]
  >([]);
  const [filteredRows, setFilteredRows] = React.useState<CSVRow[]>([]);

  React.useEffect(() => {
    if (!headers || !rows) {
      return;
    }
    const { headers: headersArr, rows: rowsArr } = filterCSV(
      headers,
      rows,
      isHidingEmptyData,
    );
    setFilteredHeaders(headersArr);
    setFilteredRows(rowsArr);
  }, [headers, isHidingEmptyData, rows]);

  return {
    headers: filteredHeaders,
    rows: filteredRows,
    setHeaders,
    setRows,
  };
}
